const layouts = {
  Large: {
    Background: 100,
    Floor: 600,
    Ceiling: 200,
    Wall_A: 300,
    Wall_B: 400,
    Wall_C: 500,
    Wall_A_Accent_Mask: 700,
    Global_Shadow_Overlay: 800,
    Window_Default: 900,
    Window_Covering: 1000,
    Ceiling_Lights: 1100,
    Wall_Lights: 1300,
    Towel_Rack: 1400,
    Shower: {
      Custom60in: {
        Body: 2000,
        Floor: 2004,
        ShowerDrain: 2005,
        FloorShadow: 2006,
        ExtrusionWallRight: 2010,
        ExtrusionWallRightShadow: 2011,
        Wall: 2020,
        Wall2: 2021,
        WallAccent: 2022,
        WallAccent2: 2023,
        WallShadow: 2024,
        LargeCornerCaddie: 2025,
        Fixture: 2031,
        ShowerHead: 2032,
        ShowerPanCombo: 2033,
        LargeCornerSeat: 2034,
        CornerCaddie: 2035,
        SoapDish: 2036,
        SmallCornerShelf: 2038,
        GrabBar: 2039,
        ExtrusionWallLeftHalfWall: 2041,
        ExtrusionWallLeftShadowHalfWall: 2042,
        Threshold: 2043,
        ThresholdShadow: 2044,
        ShowerDoor: 2045,
        ShowerDoorHandle: 2046,
        ExtrusionWallLeft: 2047,
        ExtrusionWallLeftShadow: 2048,
        Overlay: 2050,
        Glass: 2060,
        PonyWall: 2070,
        PonyWallShadow: 2071,
        PonyWallCap: 5025,
        PonyWallCapShadow: 5026,
        PonyWallGlass: 5027,
      },
      Steam60in: {
        ExtrusionWallLeft: 2500,
        Body: {
          0: 2550,    // default body (no parts)
          1: 2520,    // Part = 1
          2: 2530,    // Part = 2
        },
        Fixture: 2525,
        Overlay: 2600
      },
      TubCombo: {
        WallConfiguration: 2065,
        Liner: 2027,
        ReplacementTub: 2028,
        WalkInTub: 2029,
        JettedTub: 2030,
      },
    },
    BathTub: {
      FreeStanding: {
        FixtureFloorMount: 3000,
        Base: 3005,
        Fixture: 3010,
      },
      Custom60in: {
        FixtureFloorMount: 3500,
        Base: 3505,
        Spa: 3515,
        Top: 3525,
        Fixture: 3530
      }
    },
    Toilet: 4000,
    Vanity: {
      Custom: {
        Cabinet: 5000,
        Handle: 5010,
        VanityBacksplash: 5020,
        CounterTop: 5030,
        Mirror: 5040,
        Faucet: 5050,
        Sink: 5060,
      },
      Complete: {
        VanityBacksplash: 5500,
        Faucet: 5510,
        Cabinet: 5520,
        Mirror: 5530,
      }
    }
  },
  Small: {
    Background: 100,
    Floor: 450,
    Ceiling: 200,
    Wall_A: 300,
    Wall_B: 400,
    Wall_C: 500,
    Wall_A_Accent_Mask: 700,
    Global_Shadow_Overlay: 800,
    Window_Default: 900,
    Window_Covering: 1000,
    Ceiling_Lights: 1100,
    Wall_Lights: 1300,
    Towel_Rack: 1400,
    Shower: {
      Custom60in: {
        Body: 2000,
        Floor: 2004,
        ShowerDrain: 2005,
        FloorShadow: 2006,
        ExtrusionWallRight: 2010,
        ExtrusionWallRightShadow: 2011,
        Wall: 2020,
        Wall2: 2021,
        WallAccent: 2022,
        WallAccent2: 2023,
        WallShadow: 2024,
        LargeCornerCaddie: 2025,
        Fixture: 2031,
        ShowerHead: 2032,
        ShowerPanCombo: 2033,
        LargeCornerSeat: 2034,
        CornerCaddie: 2035,
        SoapDish: 2036,
        SmallCornerShelf: 2038,
        GrabBar: 2039,
        ExtrusionWallLeftHalfWall: 2041,
        ExtrusionWallLeftShadowHalfWall: 2042,
        Threshold: 2043,
        ThresholdShadow: 2044,
        ShowerDoor: 2045,
        ShowerDoorHandle: 2046,
        ExtrusionWallLeft: 2047,
        ExtrusionWallLeftShadow: 2048,
        Overlay: 2050,
        Glass: 2060,
        PonyWall: 2070,
        PonyWallShadow: 2071,
        PonyWallCap: 5025,
        PonyWallCapShadow: 5026,
        PonyWallGlass: 5027,
      },
      Steam60in: {
        ExtrusionWallLeft: 2500,
        Body: {
          0: 2550,    // default body (no parts)
          1: 2520,    // Part = 1
          2: 2530,    // Part = 2
        },
        Fixture: 2525,
        Overlay: 2600
      },
      TubCombo: {
        WallConfiguration: 2065,
        Liner: 2027,
        ReplacementTub: 2028,
        WalkInTub: 2029,
        JettedTub: 2030,
      },
    },
    BathTub: {
      FreeStanding: {
        FixtureFloorMount: 3000,
        Base: 3005,
        Fixture: 3010,
      },
      Custom60in: {
        FixtureFloorMount: 3500,
        Base: 3505,
        Spa: 3515,
        Top: 3525,
        Fixture: 3530
      }
    },
    Toilet: 4000,
    Vanity: {
      Custom: {
        Cabinet: 5000,
        Handle: 5010,
        VanityBacksplash: 5020,
        CounterTop: 5030,
        Mirror: 5040,
        Faucet: 5050,
        Sink: 5060,
      },
      Complete: {
        VanityBacksplash: 5500,
        Faucet: 5510,
        Cabinet: 5520,
        Mirror: 5530,
      }
    }
  }
};

export default {
  layouts,
  getMenuByHoveredLayer: (currentLayout, layer) => {

    // console.log('currentLayout', currentLayout);
    // console.log('layer', layer);

    switch (layer.zIndex) {

      // General
      case layouts[currentLayout].Floor:
        return {
          parent: "Floor",
          child: "Floor"
        };
      case layouts[currentLayout].Ceiling:
        return "Ceiling";
      case layouts[currentLayout].Toilet:
        return {
          parent: "Toilet",
          child: "Toilet"
        };
      case layouts[currentLayout].Window_Default:
        return "Window";

      // case layouts[currentLayout].Shower.Steam60in.ExtrusionWallLeft:
      // case layouts[currentLayout].Shower.Steam60in.Body["1"]:
      // case layouts[currentLayout].Shower.Steam60in.Body["2"]:
      // case layouts[currentLayout].Shower.Steam60in.Fixture:
      //     return {
      //         parent: "Shower",
      //         child: "Shower Body"
      //     };
      case layouts[currentLayout].Wall_A:
        return {
          parent: "Walls",
          child: "Wall A"
        };
      case layouts[currentLayout].Wall_C:
        return {
          parent: "Walls",
          child: "Wall C"
        };
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallRight:
        return {
          parent: "Walls",
          child: "Right Shower Wall"
        };
      case layouts[currentLayout].Vanity.Custom.Mirror:
        return {
          parent: "Vanity",
          child: "Mirror"
        };
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallLeft:
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallLeftHalfWall:
      case layouts[currentLayout].Shower.Custom60in.PonyWall:
        return "left_wall_custom";
      case layouts[currentLayout].Vanity.Custom.VanityBacksplash:
      case layouts[currentLayout].Wall_A_Accent_Mask:
      case layouts[currentLayout].Wall_B:
        return "wall_b_custom";
      case layouts[currentLayout].Vanity.Complete.Cabinet:
      case layouts[currentLayout].Vanity.Custom.Handle:
      case layouts[currentLayout].Vanity.Custom.CounterTop:
      case layouts[currentLayout].Vanity.Custom.Faucet:
      case layouts[currentLayout].Vanity.Custom.Sink:
      case layouts[currentLayout].Vanity.Custom.Cabinet:
        return "vanity_custom";

      case layouts[currentLayout].Shower.Custom60in.Threshold:
        return {
          parent: "Shower",
          child: "Threshold"
        };
      case layouts[currentLayout].Shower.Custom60in.WallAccent:
      case layouts[currentLayout].Shower.Custom60in.WallAccent2:
        return {
          parent: "Shower",
          child: "Shower Walls Accent"
        };
      case layouts[currentLayout].Shower.Custom60in.CornerCaddie:
        return {
          parent: "Shower Accessories",
          child: "Corner Caddie"
        };
      case layouts[currentLayout].Shower.Custom60in.LargeCornerCaddie:
        return {
          parent: "Shower Accessories",
          child: "Large Corner Caddie"
        };
      case layouts[currentLayout].Shower.Custom60in.LargeCornerSeat:
        return {
          parent: "Shower Accessories",
          child: "Large Corner Seat"
        };
      case layouts[currentLayout].Shower.Custom60in.SoapDish:
        return {
          parent: "Shower Accessories",
          child: "Soap Dish"
        };
      case layouts[currentLayout].Shower.Custom60in.SmallCornerShelf:
        return {
          parent: "Shower Accessories",
          child: "Small Corner Shelf"
        };
      case layouts[currentLayout].Shower.Custom60in.GrabBar:
        return {
          parent: "Shower Accessories",
          child: "Grab Bar"
        };
      case layouts[currentLayout].Shower.Custom60in.Glass:
      case layouts[currentLayout].Shower.Custom60in.Floor:
      case layouts[currentLayout].Shower.Custom60in.ShowerPanCombo:
      case layouts[currentLayout].Shower.Custom60in.Wall:
      case layouts[currentLayout].Shower.Custom60in.Wall2:
      case layouts[currentLayout].Shower.Custom60in.Fixture:
      case layouts[currentLayout].Shower.Custom60in.ShowerHead:
      case layouts[currentLayout].Shower.Custom60in.Body:
      case layouts[currentLayout].Shower.Custom60in.Overlay:
      case layouts[currentLayout].Shower.Custom60in.ShowerDoor:
      case layouts[currentLayout].Shower.Custom60in.ShowerDoorHandle:
      case layouts[currentLayout].Shower.Steam60in.ExtrusionWallLeft:
      case layouts[currentLayout].Shower.Steam60in.Body["1"]:
      case layouts[currentLayout].Shower.Steam60in.Body["2"]:
      case layouts[currentLayout].Shower.Steam60in.Fixture:
        return "shower_custom";
      // BathTub
      case layouts[currentLayout].BathTub.Custom60in.Top:
      case layouts[currentLayout].BathTub.Custom60in.Spa:
      case layouts[currentLayout].BathTub.Custom60in.Base:
      case layouts[currentLayout].BathTub.FreeStanding.Base:
      case layouts[currentLayout].BathTub.FreeStanding.Fixture:
      case layouts[currentLayout].BathTub.FreeStanding.FixtureFloorMount:
      case layouts[currentLayout].BathTub.Custom60in.Fixture:
      case layouts[currentLayout].BathTub.Custom60in.FixtureFloorMount:
        return "bathtub_custom";
      // BathTub
      case layouts[currentLayout].Shower.TubCombo.Liner:
      case layouts[currentLayout].Shower.TubCombo.ReplacementTub:
      case layouts[currentLayout].Shower.TubCombo.WalkInTub:
      case layouts[currentLayout].Shower.TubCombo.JettedTub:
      case layouts[currentLayout].Shower.TubCombo.WallConfiguration:
        return "shower_combo";
      // BathTub
      case layouts[currentLayout].Shower.Custom60in.PonyWallCap:
      case layouts[currentLayout].Shower.Custom60in.PonyWallGlass:
        return "shower_pony_wall";
      default:
        return ""
    }
  },
  getLayerDimensions: (zIndex, currentLayout) => {
    switch (zIndex) {
      // General
      case layouts[currentLayout].Floor:
        return {
          polygonArray: [[80,770],[1620,770],[1620,1080],[80,1080]],
          width: 1540,
          height: 310
        };
      case layouts[currentLayout].Ceiling:
        return {
          polygonArray: [[0,0],[1620,0],[1620,320],[0,320]],
          width: 1620,
          height: 320
        };
      case layouts[currentLayout].Toilet:
        return {
          polygonArray: [[500,640],[820,640],[820,960],[500,960]],
          width: 320,
          height: 320
        };
      case layouts[currentLayout].Window_Default:
      case layouts[currentLayout].Window_Covering:
        return {
          polygonArray: [[1200,240],[1400,240],[1400,780],[1200,780]],
          width: 200,
          height: 540
        };
      case layouts[currentLayout].Shower.Steam60in.ExtrusionWallLeft:
      case layouts[currentLayout].Shower.Steam60in.Body["1"]:
      case layouts[currentLayout].Shower.Steam60in.Body["2"]:
      case layouts[currentLayout].Shower.Steam60in.Fixture:
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallRight:
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallLeft:
      case layouts[currentLayout].Shower.Custom60in.ExtrusionWallLeftHalfWall:
      case layouts[currentLayout].Shower.Custom60in.PonyWall:
      case layouts[currentLayout].Shower.Custom60in.Threshold:
      case layouts[currentLayout].Shower.Custom60in.Glass:
      case layouts[currentLayout].Shower.Custom60in.Floor:
      case layouts[currentLayout].Shower.Custom60in.ShowerPanCombo:
      case layouts[currentLayout].Shower.Custom60in.Wall:
      case layouts[currentLayout].Shower.Custom60in.Wall2:
      case layouts[currentLayout].Shower.Custom60in.WallAccent:
      case layouts[currentLayout].Shower.Custom60in.WallAccent2:
      case layouts[currentLayout].Shower.Custom60in.Fixture:
      case layouts[currentLayout].Shower.Custom60in.ShowerHead:
      case layouts[currentLayout].Shower.Custom60in.Body:
      case layouts[currentLayout].Shower.Custom60in.Overlay:
      case layouts[currentLayout].Shower.Custom60in.ShowerDoor:
      case layouts[currentLayout].Shower.Custom60in.ShowerDoorHandle:
      case layouts[currentLayout].Shower.Custom60in.PonyWallCap:
      case layouts[currentLayout].Shower.Custom60in.PonyWallGlass:
      case layouts[currentLayout].Shower.Custom60in.SoapDish:
      case layouts[currentLayout].Shower.Custom60in.LargeCornerSeat:
      case layouts[currentLayout].Shower.Custom60in.LargeCornerCaddie:
      case layouts[currentLayout].Shower.Custom60in.CornerCaddie:
      case layouts[currentLayout].Shower.Custom60in.SmallCornerShelf:
      case layouts[currentLayout].Shower.Custom60in.GrabBar:
      case layouts[currentLayout].Shower.TubCombo.Liner:
      case layouts[currentLayout].Shower.TubCombo.ReplacementTub:
      case layouts[currentLayout].Shower.TubCombo.WalkInTub:
      case layouts[currentLayout].Shower.TubCombo.JettedTub:
      case layouts[currentLayout].Shower.TubCombo.WallConfiguration:
        return {
          polygonArray: [[570,0],[1500,0],[1540,1080],[570,1080]],
          width: 970,
          height: 1080
        };
      case layouts[currentLayout].Wall_A:
        return {
          polygonArray: [[0,0],[130,0],[130,1080],[0,1080]],
          width: 130,
          height: 1080
        };
      case layouts[currentLayout].Wall_A_Accent_Mask:
        return {
          polygonArray: [[90,120],[700,120],[700,690],[90,690]],
          width: 610,
          height: 570
        };
      case layouts[currentLayout].Wall_C:
        return {
          polygonArray: [[900,0],[1620,0],[1620,1080],[900,1080]],
          width: 720,
          height: 1080
        };
      case layouts[currentLayout].Wall_B:
        return {
          polygonArray: [[80,140],[1080,140],[1080,990],[80,990]],
          width: 1000,
          height: 850
        };
      case layouts[currentLayout].Vanity.Custom.Mirror:
        return {
          polygonArray: [[80,170],[700,170],[700,630],[80,630]],
          width: 620,
          height: 460
        };
      case layouts[currentLayout].Vanity.Custom.VanityBacksplash:
        return {
          polygonArray: [[80,580],[700,580],[700,680],[80,680]],
          width: 620,
          height: 100
        };
      case layouts[currentLayout].Vanity.Custom.CounterTop:
        return {
          polygonArray: [[80,610],[770,610],[770,710],[80,710]],
          width: 690,
          height: 100
        };
      case layouts[currentLayout].Vanity.Custom.Faucet:
      case layouts[currentLayout].Vanity.Custom.Sink:
        return {
          polygonArray: [[80,500],[700,500],[700,710],[80,710]],
          width: 620,
          height: 210
        };
      case layouts[currentLayout].Vanity.Complete.Cabinet:
      case layouts[currentLayout].Vanity.Custom.Handle:
      case layouts[currentLayout].Vanity.Custom.Cabinet:
        return {
          polygonArray: [[80,500],[780,500],[780,1070],[80,1070]],
          width: 700,
          height: 570
        };
      // BathTub
      case layouts[currentLayout].BathTub.Custom60in.Top:
      case layouts[currentLayout].BathTub.Custom60in.Spa:
      case layouts[currentLayout].BathTub.Custom60in.Base:
      case layouts[currentLayout].BathTub.FreeStanding.Base:
      case layouts[currentLayout].BathTub.FreeStanding.Fixture:
      case layouts[currentLayout].BathTub.FreeStanding.FixtureFloorMount:
      case layouts[currentLayout].BathTub.Custom60in.Fixture:
      case layouts[currentLayout].BathTub.Custom60in.FixtureFloorMount:
        return {
          polygonArray: [[750,580],[1620,580],[1620,1080],[750,1080]],
          width: 870,
          height: 500
        };
      default:
        return null
    }
  }
}


